import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "sequencing"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = {
  class: "answer-option"
};
const _hoisted_7 = {
  style: {
    "display": "inline-block"
  },
  class: "menu"
};
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default"), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("p", {
      key: 'questionIndex' + questionIndex
    }, [_createElementVNode("span", _hoisted_7, _toDisplayString(questionIndex + $props.questionInfo.menu), 1), _createElementVNode("span", {
      innerHTML: questionItem.questionStem
    }, null, 8, _hoisted_8)]);
  }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer",
      key: 'que' + questionIndex
    }, [_createElementVNode("p", null, "● Step" + _toDisplayString(questionIndex + 1) + "：", 1), _createVNode(_component_el_select, {
      modelValue: $setup.answer[questionIndex - 0],
      "onUpdate:modelValue": $event => $setup.answer[questionIndex - 0] = $event,
      class: "m-2",
      placeholder: " ",
      size: "small",
      clearable: "",
      onChange: $setup.setAnswer
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (item, i) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
          key: i + 'questionOrder',
          label: item.questionStem,
          value: i - 0 + 1
        }, null, 8, ["label", "value"])), [[_vShow, $setup.answer.indexOf(i + 1) === -1]]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]);
  }), 128))])]);
}